<div class="flex h-screen bg-gray-100">
  <div class="w-64 bg-white shadow-lg flex flex-col">
    <div class="p-6 border-b">
      <img src="assets/saltus-spp-black.svg" alt="Saltus Partners" class="h-16 w-auto">
    </div>
    <nav class="mt-6 flex-1">
      <a
        routerLink="/sites"
        routerLinkActive="bg-blue-50 text-blue-700 border-r-2 border-blue-700"
        [routerLinkActiveOptions]="{ exact: true }"
        class="flex items-center px-6 py-3 text-gray-700 hover:bg-gray-50 transition-colors">
        <svg class="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"></path>
        </svg>
        Sites
      </a>
      @if (auth.isPlatformAdmin$ | async) {
        <a
          routerLink="/domains"
          routerLinkActive="bg-blue-50 text-blue-700 border-r-2 border-blue-700"
          class="flex items-center px-6 py-3 text-gray-700 hover:bg-gray-50 transition-colors">
          <svg class="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
          Domains
        </a>
        <a
          routerLink="/users"
          routerLinkActive="bg-blue-50 text-blue-700 border-r-2 border-blue-700"
          class="flex items-center px-6 py-3 text-gray-700 hover:bg-gray-50 transition-colors">
          <svg class="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13.5 3a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z"></path>
          </svg>
          Users
        </a>
      }
    </nav>
    <div class="border-t border-gray-200 mt-auto">
      @if (auth.session$ | async; as session) {
        <div class="px-6 py-4">
          <p class="text-xs text-gray-500 mb-1">Signed in as</p>
          <p class="text-sm text-gray-800 truncate" [title]="session.email">{{ session.email }}</p>
          <button (click)="logout()" class="mt-2 text-sm text-blue-600 hover:underline">Sign out</button>
        </div>
      }
    </div>
  </div>
  <div class="flex-1 overflow-auto">
    <router-outlet></router-outlet>
  </div>
</div>
